import { Component, Input } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-dialog-before-leave',
    templateUrl: './general-dialog.component.html',
    styleUrls: ['./general-dialog.component.less'],
})
export class GeneralDialogComponent {
    @Input() message: string;
    @Input() cancelText: string;
    @Input() confirmText: string;
    @Input() title: string;
    @Input() hasTitle = false;

    submitting = false;

    constructor(private modal: NzModalRef) {}

    confirm() {
        this.modal.triggerOk();
    }

    discard() {
        this.modal.close(false);
    }

    destroy() {}
}
